import { SET_PAYOUTS } from 'constants/payouts';
import type { Payout } from 'models/payout';

export const setPayouts = (payouts: Payout[]) => ({
  type: SET_PAYOUTS,
  payload: payouts,
});
